//imports
import {
    EVENT_DELETE_OPEN_MODAL,
    EVENT_DELETE_REQUEST,
    EVENT_DELETE_RESULT,
    CLEAR_REDUX,
} from 'Redux/actionTypes';

//initial values
const INIT_STATE = {
    openModal: false,
    loading: false,
    result: null,
    event: null,
};


//change redux object
export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case EVENT_DELETE_OPEN_MODAL:
            return { ...state, openModal: action.payload.open, event: action.payload.event }

        case EVENT_DELETE_REQUEST:
            return { ...state, loading: true }

        case EVENT_DELETE_RESULT:
            return { ...state, loading: false, result: action.payload }

        case CLEAR_REDUX:
            return ["", "EVENT_DELETE"].includes(action.payload.option)
                ? action.payload.parameters
                    ? { ...state, ...action.payload.parameters }
                    : { ...INIT_STATE }
                : { ...state };

        default:
            return state;
    }
};